import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  Grid,
  IconButton,
  Input,
  InputLabel,
  Link,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';

const data = [
  {
    sl: 1,
    refNo: '420125080000002',
    policyNo: '4101025080000001-00',
    batchNo: '2025080114085149918157142',
    corporate: 'DML Group of companies',
    fileName: '420125080000002.xlsx',
    status: 'Validation completed',
    uploadedBy: 'Mr Harshad patil',
    uploadTime: '01 Aug, 2025 02:08 PM',
    downloadLink: '#',
  },
];

const PremiumValidation = () => {
  const [filterType, setFilterType] = useState('');
  const [uploadDate, setUploadDate] = useState('');
  const [policyCode, setPolicyCode] = useState('');
  const [showMatrix, setShowMatrix] = useState(false);

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const ageBands = ['00-25', '26-35', '36-45', '46-55', '56-65', '66-70', '71-75', '76-80', '81-120'];

  const rackRateData = [
    {
      sumInsured: 100000,
      rates: ['', '', '', '', '', '', '', '', ''],
    },
    {
      sumInsured: 200000,
      rates: ['', '', '', '', '', '', '', '', ''],
    },
    {
      sumInsured: 300000,
      rates: ['', '', '', '', '', '', '', '', ''],
    },
    {
      sumInsured: 400000,
      rates: ['', '', '', '', '', '', '', '', ''],
    },
    {
      sumInsured: 500000,
      rates: ['1498.64', '2060.95', '3135.64', '4713.48', '7029.79', '10426.04', '14.076.02', '18477.93', '24203.64'],
    },
    {
      sumInsured: 600000,
      rates: ['', '', '', '', '', '', '', '', ''],
    },
  ];

  const memberCountData = [
    {
      sumInsured: 100000,
      rates: ['', '', '', '', '', '', '', '', ''],
    },
    {
      sumInsured: 200000,
      rates: ['', '', '', '', '', '', '', '', ''],
    },
    {
      sumInsured: 300000,
      rates: ['', '', '', '', '', '', '', '', ''],
    },
    {
      sumInsured: 400000,
      rates: ['', '', '', '', '', '', '', '', ''],
    },
    {
      sumInsured: 500000,
      rates: ['50', '47', '54', '53', '47', '15', '13', '9', '6'],
    },
    {
      sumInsured: 600000,
      rates: ['', '', '', '', '', '', '', '', ''],
    },
  ];

  const memberUploadData = [
    { sumInsured: 100000, counts: ['', '', '', '', '', '', '', '', ''] },
    { sumInsured: 200000, counts: ['', '', '', '', '', '', '', '', ''] },
    { sumInsured: 300000, counts: ['', '', '', '', '', '', '', '', ''] },
    { sumInsured: 400000, counts: ['', '', '', '', '', '', '', '', ''] },
    { sumInsured: 500000, counts: ['50', '48', '53', '53', '48', '14', '13', '11', '4'] },
    { sumInsured: 600000, counts: ['', '', '', '', '', '', '', '', ''] },
  ];

  const [values, setValues] = React.useState({
    basic: '1572237.85',
    cgst: '0.0',
    sgst: '0.0',
    igst: '283002.813',
    gross: '1855240.66',
  });

  const [valuesOne, setValuesOne] = React.useState({
    basic: '1556315.49',
    cgst: '0.0',
    sgst: '0.0',
    igst: '280136.79',
    gross: '1836452.28',
  });
  const handleMatrix = () => {
    setShowMatrix(true);
  };

  return (
    <Box>
      <Box component={Paper} p={2} mb={2} fontWeight="bold">
        Premium Validation UW
      </Box>
      <Box
        style={{
          display: 'flex',
          //   justifyContent: 'end',
          alignItems: 'flex-end',
          marginTop: '1rem',
          flexDirection: 'column',
        }}>
        <Box display="flex" alignItems="flex-end" gap="2rem" style={{ display: 'flex', gap: '1rem' }}>
          {/* Filter Type Dropdown */}
          <Box sx={{ width: 220 }}>
            <FormControl variant="outlined" size="small" fullWidth>
              <InputLabel id="filter-type-label">Search By</InputLabel>
              <Select
                labelId="filter-type-label"
                label="Filter By"
                value={filterType}
                onChange={e => setFilterType(e.target.value)}>
                <MenuItem value="">Select...</MenuItem>
                <MenuItem value="policy">Policy Code</MenuItem>
                <MenuItem value="date">Upload Date</MenuItem>
              </Select>
            </FormControl>
          </Box>

          {/* Conditional Inputs */}
          {filterType === 'policy' && (
            <Box>
              <TextField
                label="Policy Code"
                size="small"
                value={policyCode}
                onChange={e => setPolicyCode(e.target.value)}
                InputLabelProps={{ shrink: true }}
              />
            </Box>
          )}

          {filterType === 'date' && (
            <>
              <Box sx={{ minWidth: 160 }}>
                <TextField
                  label="Upload Date"
                  type="date"
                  size="small"
                  fullWidth
                  value={uploadDate}
                  onChange={e => setUploadDate(e.target.value)}
                  InputLabelProps={{ shrink: true }}
                />
              </Box>
            </>
          )}

          {/* Search Button with extra margin on Date Range */}
          <Box style={{ display: 'flex', gap: '1rem' }}>
            <Button variant="contained" color="primary">
              Search
            </Button>
          </Box>
        </Box>
        {/* <Box style={{ marginTop: '1rem', marginRight: '5.7rem' }} sx={{ width: 220 }}>
          <TextField
            type="file"
            variant="outlined"
            size="small"
            InputProps={{
              sx: {
                height: '50px',
              },
            }}
            inputProps={{
              style: {
                padding: '11px',
              },
            }}
            onChange={handleFileChange}
          />
        </Box> */}
      </Box>
      <Box style={{ marginTop: '2rem' }}>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 1200, borderCollapse: 'collapse' }}>
            <TableHead>
              <TableRow sx={{ backgroundColor: '#00A0E3', color: 'white' }}>
                {[
                  'SL#',
                  'Ref No',
                  'Policy No',
                  'Batch No',
                  'Corporate',
                  'File Name',
                  'Status',
                  'Uploaded By',
                  'Upload Time',
                  //   'Download',
                  'Upload',
                ].map((heading, index) => (
                  <TableCell
                    key={index}
                    sx={{
                      color: 'white',
                      fontWeight: 'bold',
                      border: '1px solid white',
                      textAlign: 'center',
                      whiteSpace: 'nowrap',
                    }}>
                    {heading}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((row, index) => (
                <TableRow key={index}>
                  <TableCell align="center">{row.sl}</TableCell>
                  <TableCell align="center">{row.refNo}</TableCell>
                  <TableCell align="center">{row.policyNo}</TableCell>
                  <TableCell align="center">{row.batchNo}</TableCell>
                  <TableCell align="center">{row.corporate}</TableCell>
                  <TableCell align="center">{row.fileName}</TableCell>
                  <TableCell align="center">{row.status}</TableCell>
                  <TableCell align="center">{row.uploadedBy}</TableCell>
                  <TableCell align="center">{row.uploadTime}</TableCell>
                  {/* <TableCell align="center">
                    <Link href={row.downloadLink} underline="hover" onClick={handleDownload}>
                      Download File
                    </Link>
                  </TableCell> */}
                  <TableCell align="center">
                    <Button
                      size="small"
                      onClick={handleMatrix}
                      variant="contained"
                      color="primary"
                      style={{ fontSize: '8px' }}>
                      Premium Matrix
                    </Button>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
      <Dialog
        open={showMatrix}
        fullWidth
        maxWidth="lg"
        aria-labelledby="form-dialog-title"
        PaperProps={{
          style: isSmallScreen
            ? {
                margin: 'auto', // center it on small screens
              }
            : {
                position: 'absolute',
                top: 20,
                // left: 300,
                margin: 0,
              },
        }}>
        <DialogTitle id="form-dialog-title">
          <Box component={Paper} p={2} mb={2} fontWeight="bold">
            Approve Premium & Enroll Member
          </Box>
        </DialogTitle>
        <DialogContent>
          <DialogContent>
            <Box
              mt={2}
              display="flex"
              justifyContent="center"
              gap={2}
              flexWrap="nowrap"
              style={{ display: 'flex', gap: '0.5rem' }}>
              {/* Rack Rate Details Table */}
              <Box width="1200px">
                <Typography align="center" variant="subtitle1" gutterBottom>
                  Rack Rate Details
                </Typography>
                <TableContainer
                  component={Paper}
                  style={{
                    maxWidth: '100%',
                    overflowX: 'auto',
                    border: '1px solid #ccc',
                    padding: '4px',
                  }}>
                  <Table
                    size="small"
                    style={{
                      fontSize: '10px',
                    }}>
                    <TableHead>
                      <TableRow>
                        <TableCell style={{ fontSize: '10px', padding: '4px' }}>
                          <strong>Sum Insured</strong>
                        </TableCell>
                        {ageBands.map((band, idx) => (
                          <TableCell key={idx} align="center" style={{ fontSize: '10px', padding: '4px' }}>
                            <strong>{band}</strong>
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {rackRateData.map((row, idx) => (
                        <TableRow key={idx}>
                          <TableCell style={{ fontSize: '10px', padding: '4px' }}>{row.sumInsured}</TableCell>
                          {row.rates.map((rate, i) => (
                            <TableCell key={i} align="center" style={{ fontSize: '10px', padding: '4px' }}>
                              {rate}
                            </TableCell>
                          ))}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Box>
            <Box
              mt={2}
              display="flex"
              justifyContent="center"
              gap={2}
              flexWrap="nowrap"
              style={{ display: 'flex', gap: '0.5rem' }}>
              {/* Rack Rate Details Table */}
              <Box width="600px">
                <Typography align="center" variant="subtitle1" gutterBottom>
                  Member Count Details
                </Typography>
                <TableContainer
                  component={Paper}
                  style={{
                    maxWidth: '100%',
                    overflowX: 'auto',
                    border: '1px solid #ccc',
                    padding: '4px',
                  }}>
                  <Table
                    size="small"
                    style={{
                      fontSize: '10px',
                    }}>
                    <TableHead>
                      <TableRow>
                        <TableCell style={{ fontSize: '10px', padding: '4px' }}>
                          <strong>Sum Insured</strong>
                        </TableCell>
                        {ageBands.map((band, idx) => (
                          <TableCell key={idx} align="center" style={{ fontSize: '10px', padding: '4px' }}>
                            <strong>{band}</strong>
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {memberCountData.map((row, idx) => (
                        <TableRow key={idx}>
                          <TableCell style={{ fontSize: '10px', padding: '4px' }}>{row.sumInsured}</TableCell>
                          {row.rates.map((rate, i) => (
                            <TableCell key={i} align="center" style={{ fontSize: '10px', padding: '4px' }}>
                              {rate}
                            </TableCell>
                          ))}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>

              {/* Member Count Table */}
              <Box width="600px">
                <Typography align="center" variant="subtitle1" gutterBottom>
                  Member Upload FDetails
                </Typography>
                <TableContainer
                  component={Paper}
                  style={{
                    maxWidth: '100%',
                    overflowX: 'auto',
                    border: '1px solid #ccc',
                    padding: '4px',
                  }}>
                  <Table size="small" style={{ fontSize: '10px' }}>
                    <TableHead>
                      <TableRow>
                        <TableCell style={{ fontSize: '10px', padding: '4px' }}>
                          <strong>Sum Insured</strong>
                        </TableCell>
                        {ageBands.map((band, idx) => (
                          <TableCell key={idx} align="center" style={{ fontSize: '10px', padding: '4px' }}>
                            <strong>{band}</strong>
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {memberUploadData.map((row, idx) => (
                        <TableRow key={idx}>
                          <TableCell style={{ fontSize: '10px', padding: '4px' }}>{row.sumInsured}</TableCell>
                          {row.counts.map((count, i) => (
                            <TableCell key={i} align="center" style={{ fontSize: '10px', padding: '4px' }}>
                              {count}
                            </TableCell>
                          ))}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Box>
            <Box
              mt={2}
              display="flex"
              justifyContent="center"
              gap={2}
              flexWrap="nowrap"
              style={{ display: 'flex', gap: '0.5rem' }}>
              <Box
                border={1}
                borderColor="#00b0f0"
                borderRadius={2}
                p={3}
                width="600px"
                mx="auto"
                style={{ marginTop: '1rem' }}>
                <Grid container spacing={2} alignItems="center">
                  {/* Fields */}
                  {[
                    { label: 'Basic Premium', key: 'basic' },
                    { label: 'CGST (9%)', key: 'cgst' },
                    { label: 'SGST (9%)', key: 'sgst' },
                    { label: 'IGST (18%)', key: 'igst' },
                    //   { label: 'Tax Amount', key: 'tax' },
                    { label: 'Gross Premium', key: 'gross' },
                  ].map(field => (
                    <React.Fragment key={field.key}>
                      <Grid item xs={6}>
                        <Typography>
                          <span style={{ color: 'red' }}>*</span> {field.label} :
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <TextField fullWidth size="small" value={values[field.key]} InputProps={{ readOnly: true }} />
                      </Grid>
                    </React.Fragment>
                  ))}
                </Grid>
              </Box>
              <Box
                border={1}
                borderColor="#00b0f0"
                borderRadius={2}
                p={3}
                width="600px"
                mx="auto"
                style={{ marginTop: '1rem' }}>
                <Grid container spacing={2} alignItems="center">
                  {/* Fields */}
                  {[
                    { label: 'Basic Premium', key: 'basic' },
                    { label: 'CGST (9%)', key: 'cgst' },
                    { label: 'SGST (9%)', key: 'sgst' },
                    { label: 'IGST (18%)', key: 'igst' },
                    //   { label: 'Tax Amount', key: 'tax' },
                    { label: 'Gross Premium', key: 'gross' },
                  ].map(field => (
                    <React.Fragment key={field.key}>
                      <Grid item xs={6}>
                        <Typography>
                          <span style={{ color: 'red' }}>*</span> {field.label} :
                        </Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <TextField fullWidth size="small" value={valuesOne[field.key]} InputProps={{ readOnly: true }} />
                      </Grid>
                    </React.Fragment>
                  ))}
                </Grid>
              </Box>
            </Box>
            <Box
              width="600px"
              mt={2}
              sx={{
                display: 'flex',
                justifyContent: 'center',
                border: '1px solid #42a5f5',
                padding: '1rem',
                margin: '0 auto', // ✅ centers the Box horizontally
              }}>
              <FormControl variant="outlined" size="small" fullWidth>
                <InputLabel id="uw-approve-label">
                  <b>U/W to Approve</b>
                </InputLabel>
                <Select labelId="uw-approve-label" label="U/W to Approve" defaultValue="">
                  <MenuItem value="">
                    <em>--- Select One ---</em>
                  </MenuItem>
                  <MenuItem value="without">WithOut Adjustment</MenuItem>
                  <MenuItem value="with">With Adjustment</MenuItem>
                </Select>
              </FormControl>
            </Box>
          </DialogContent>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            onClick={() => {
              setShowMatrix(false);
              //   setShowRackRateDetails(false);
              //   setValues(prev => ({
              //     ...prev,
              //     frequency: 'Annual',
              //   }));
            }}
            style={{
              backgroundColor: '#d32f2f',
              color: 'white',
              marginLeft: '1rem',
            }}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default PremiumValidation;
